import { render, staticRenderFns } from "./EditHomepageServices.vue?vue&type=template&id=15c05c36&scoped=true&"
import script from "./EditHomepageServices.vue?vue&type=script&lang=js&"
export * from "./EditHomepageServices.vue?vue&type=script&lang=js&"
import style0 from "./EditHomepageServices.vue?vue&type=style&index=0&id=15c05c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c05c36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAlert,VBtn,VCol,VContainer,VIcon,VRow,VSwitch})
